import store from './index'
import { bounds } from './stateBindings'
import { getInitialState } from './initialState'

const mutations = {
  ...Object.keys(bounds).reduce((acc, item) => {
    const loading = item + 'Loading'
    acc['set_' + item] = (state, data) => {
      state[item] = data
      state[loading] = data === null
    }
    acc[`set_${loading}`] = (state, value) => {
      state[loading] = value
    }
    acc['set_' + item + 'Binding'] = (state, data) => {
      state[item + 'Binding'] = data
      if (data === null) {
        state[item] = item.slice(-1) === 's' ? [] : {}
      }
    }
    return acc
  }, {}),

  // set_user is separate as its data needs to be copied instead of set.
  set_userBinding(state, data) {
    state.userBinding = data
  },
  set_user(state, data) {
    state.mfaEnabled = data.multiFactor
      ? data.multiFactor.enrolledFactors.length > 0
      : false
    // copy the object as firebase will overwrite the currentUser object which breaks Vue's observing
    state.user = {
      uid: data.uid,
      auth: data.auth,
      email: data.email,
      photoURL: data.photoURL,
      tenantId: data.tenantId,
      metadata: data.metadata,
      providerId: data.providerId,
      accessToken: data.accessToken,
      displayName: data.displayName,
      isAnonymous: data.isAnonymous,
      providerData: data.providerData,
      emailVerified: data.emailVerified,
      reloadUserInfo: data.reloadUserInfo,
      reloadListener: data.reloadListener,
      stsTokenManager: data.stsTokenManager,
      proactiveRefresh: data.proactiveRefresh
    }
  },
  set_claimsBinding(state, data) {
    state.claimsBinding = data
  },
  set_claims(state, data) {
    // copy the object as firebase will overwrite the object which breaks Vue's observing
    state.claims = { ...data }
    state.claimsLoading = data === null
  },
  set_isConnectedBinding(state, data) {
    state.isConnectedBinding = data
  },
  set_isConnected(state, data) {
    state.isConnected = data
  },
  set_selectedAccountId(state, data) {
    state.selectedAccountId = data
  },
  set_userLookups(state, data) {
    state.userLookups[data] = true
  },
  set_drawer(state, data) {
    state.drawer = data
  },
  set_snackbar(state, data) {
    state.snackbar = data
  },
  set_showSnackbar(state, data) {
    state.showSnackbar = data
  },
  set_knownUsers(state, data) {
    state['knownUsers'] = data
    state['knownUsersLoading'] = data === null
  },
  set_knownUsersBinding(state, data) {
    state.knownUsersBinding = data
  },
  set_knownUsersIncludes(state, data) {
    state.knownUsersIncludes[data] = true
  },
  set_titleBarContents(state, data) {
    state.titleBarContents = data
  },
  set_sharesBinding(state, data) {
    state.sharesBinding = data
  },
  set_shares(state, data) {
    state.shares = data
    state.sharesLoading = data === null
  },
  set_sharesLoading(state, data) {
    state.sharesLoading = data
  },
  set_companyBinding(state, data) {
    state.companyBinding = data
  },
  set_company(state, data) {
    state.company = data
    state.companyLoading = data === null
  },
  set_companyLoading(state, data) {
    state.companyLoading = data
  },
  resetState() {
    store.replaceState(getInitialState())
  }
}

export default mutations
